"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pangolin = void 0;
exports.pangolin = {
    router: '0xE54Ca86531e17Ef3616d22Ca28b0D458b6C89106',
};
